import React from "react";
import { useFormControlWrapper } from "./FormControlWrapperProvider";
import { FormControlLabelProps } from "./defines";
import { InfoTooltip } from "@cmp-src/data-display/InfoTooltip/InfoTooltip";
import { Label } from "@cmp-src/primitives/label";

export const FormControlLabel: React.FC<FormControlLabelProps> = (props) => {
  const { isInvalid } = useFormControlWrapper();
  const { children, className, isRequired, isOptional, info, ...rest } = props;
  const { id } = useFormControlWrapper();
  return (
    <span className={"flex justify-between"}>
      <Label
        {...rest}
        isInvalid={isInvalid}
        htmlFor={props.htmlFor || id}
        className={className}
      >
        <span className="flex items-center gap-1">
          {children}
          {isRequired ? (
            <span
              className={
                "inline-block font-bold text-semantic-error-foreground"
              }
            >
              *
            </span>
          ) : undefined}
        </span>
        {isOptional && <span className="text-content">Optional</span>}
      </Label>
      <span>{info && <InfoTooltip>{info}</InfoTooltip>}</span>
    </span>
  );
};
